export const primaryFontFamily = [
  'Inter',
  'Plus Jakarta Sans',
  'system-ui',
  '-apple-system',
  'Segoe UI',
  'Roboto',
  'Ubuntu',
  'Cantarell',
  'Noto Sans',
  'sans-serif',
  'Helvetica',
  'Arial',
  'Segoe UI Emoji',
  'Segoe UI Symbol',
  'Apple Color Emoji',
  'Twemoji Mozilla',
  'Noto Color Emoji',
  'EmojiOne Color',
  'Android Emoji',
].join(',');
